import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const STRATEGIES = [
  {
    id: 'absorb',
    title: 'Absorb Fees',
    description: 'Organizer covers all ticketing costs. Attendees only pay the ticket price.',
    icon: FiIcons.FiCreditCard,
    badge: 'Standard',
    color: 'indigo'
  },
  {
    id: 'split',
    title: 'Split Fees',
    description: 'Ticketing fees are divided 50/50 between organizer and attendee.',
    icon: FiIcons.FiDivide,
    badge: 'Popular',
    color: 'fuchsia'
  },
  {
    id: 'pass',
    title: 'Pass On Fees',
    description: 'All ticketing fees are added as an extra cost to the attendee.',
    icon: FiIcons.FiArrowUpRight,
    badge: 'Recommended',
    color: 'emerald'
  }
];

const FeeManagement = ({ selectedStrategy, onSelect }) => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-2">
        <label className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-400">
          Fee Management Strategy
        </label>
        <p className="text-xs text-slate-500">
          Decide how ticketing fees should be distributed between you and your attendees.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {STRATEGIES.map((strategy) => {
          const isActive = selectedStrategy === strategy.id;
          const Icon = strategy.icon;
          
          return (
            <button
              key={strategy.id}
              onClick={() => onSelect(strategy.id)}
              className={`relative group p-5 rounded-[2rem] border-2 text-left transition-all duration-300 ${
                isActive 
                  ? 'bg-white border-slate-900 shadow-xl scale-[1.02] z-10' 
                  : 'bg-slate-50 border-slate-100 hover:border-slate-200'
              }`}
            >
              <div className="flex items-start gap-4">
                <div className={`p-3 rounded-2xl transition-colors ${
                  isActive ? 'bg-slate-900 text-white' : 'bg-white text-slate-400'
                }`}>
                  <SafeIcon icon={Icon} className="w-5 h-5" />
                </div>
                
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-1">
                    <h4 className={`text-sm font-black uppercase tracking-tight ${
                      isActive ? 'text-slate-900' : 'text-slate-600'
                    }`}>
                      {strategy.title}
                    </h4>
                    {isActive && (
                      <span className={`text-[9px] font-black uppercase px-2 py-0.5 rounded-full bg-${strategy.color}-100 text-${strategy.color}-600 border border-${strategy.color}-200`}>
                        {strategy.badge}
                      </span>
                    )}
                  </div>
                  <p className={`text-[11px] leading-relaxed ${
                    isActive ? 'text-slate-500' : 'text-slate-400'
                  }`}>
                    {strategy.description}
                  </p>
                </div>

                <div className={`mt-1 transition-opacity ${isActive ? 'opacity-100' : 'opacity-0'}`}>
                  <div className="w-5 h-5 rounded-full bg-slate-900 flex items-center justify-center">
                    <SafeIcon icon={FiIcons.FiCheck} className="w-3 h-3 text-white" />
                  </div>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FeeManagement;